export default "__VITE_ASSET__Czq8C8od__"